import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Button, Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 35px 32px;
  margin-bottom: 16px;

  .ant-card-body {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 0;

    &::before,
    &::after {
      display: none;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 15px;

    .ant-card-body {
      gap: 16px;
    }
  }

  @media screen and (max-width: 561px) {
    .ant-card-body {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  text-align: right;

  @media screen and (max-width: 768px) {
    text-align: right;
    width: 100%;
  }
`;

export const Title = styled.h3`
  margin: 0;
  color: #1a295a;
  font-size: 24px;
  font-weight: ${FONT_WEIGHT.extremeBold};

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

export const SubTitle = styled.h4`
  margin: 0;
  font-size: 20px;
  color: #1a295a;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Description = styled.p`
  margin: 0;
  font-size: 18px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};

  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: center;
    text-align: center;
    align-items: center;
  }
`;

export const StyledButton = styled(Button)`
  background: #1a295a;
  color: #fff;
  border: none;
  padding: 0 16px;
  height: 36px;
  font-size: 16px;
  font-weight: ${FONT_WEIGHT.medium};
  min-width: 160px;
  width: fit-content;
  border-radius: 8px;

  &:hover {
    background: #1e2f5c;
    color: #fff;
  }
`;

export const Password = styled.div`
  margin: 0;
  font-size: 18px;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.bold};
  text-align: center;
`;

export const PasswordText = styled.span`
  margin: 0;
  font-size: 18px;
  color: #ce6239;
  font-weight: ${FONT_WEIGHT.bold};
  text-align: center;
`;
